export default function detailEditStart(data,way){
    this.dsClear();

    this.dsAdd("set",way + "/mode", "edit")
    if(data.type == "rightPanel"){
        this.dsAdd("set","rightPanel/customWidth","70%")
    }
    this.dsProcess()
}